import angular from 'angular';

import WorkflowEvents from './workflow-events/events.component';
import WorkflowRuleForm from './workflow-rule-form/rule-form.component';
import WorkflowTable from './workflow-table/workflow-table.component';
import Task from './task/task.component';
import MonitoringTaskTable from './task-table/task-table.component';
import TaskForm from './task-form/task-form.component';
import Routes from './workflows.routes';

const DEPENDENCIES = [
  WorkflowEvents,
  WorkflowRuleForm,
  WorkflowTable,
  Task,
  MonitoringTaskTable,
  TaskForm,
];

export default angular.module('autoboard.workflows', DEPENDENCIES)
  .config(Routes)
  .name;
